import type { Metatag } from '../../types/template';

type MetatagKey = 'set-cookie' | 'pragma';

const parseMetatag = (metatags?: Metatag[] | null, tagKey?: MetatagKey) => {
  const currentMetatagValues = metatags?.find(tag => tag.key === (tagKey || 'pragma'));

  const metatagValues = currentMetatagValues?.value
    ? currentMetatagValues.value.split(',')
    : [currentMetatagValues?.value];

  const metatagFormatValues = metatagValues.reduce<Array<{ [key: string]: string }>>((previous, currentTag) => {
    if (currentTag?.match(/=/gi)) {
      const currentMetatag = currentTag?.split('=');

      return [
        ...previous,
        {
          [currentMetatag[0]]: currentMetatag[1],
        },
      ];
    }

    return previous;
  }, []);

  return metatagFormatValues;
};

export default parseMetatag;
